























import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import { ClassifiedDeactivationReason, Reason } from "@/shared/interfaces/ClassifiedDeactivationReason.interface";

export default Vue.extend({
    props: {
        selected: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data: function() {
        return {
            specificId: uuidv4() as string,
        };
    },

    methods: {
        emitUpdate: function() {
            let reason: ClassifiedDeactivationReason = {
                type: "FRAUD" as unknown as Reason,
            };

            this.$emit("update", reason);
        },
    },
});
